import React, { useContext } from 'react';
import AppContext from 'context/Context';
import useToken from 'hooks/useToken';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCog,
  faBolt,
  faTags,
  faHome,
  faTimes,
  faClock,
  faRobot,
  faGlobe
} from '@fortawesome/free-solid-svg-icons';

const SupportEngineSettingsSidebar = ({
  activeSubTab = 'atajos',
  setActiveSubTab,
  isOpen = false,
  onClose,
  onBack
}) => {
  const { config: { isDark } = {} } = useContext(AppContext);
  const { idCatTipoUsuario } = useToken();
  const isAdmin = Number(idCatTipoUsuario) === 1;

  const menuItems = [
    {
      id: 'atajos',
      label: 'Atajos',
      shortLabel: 'Atajos',
      icon: faBolt,
      activeColor: '#059669',
      badge: null
    },
    {
      id: 'incidencias',
      label: 'Incidencias',
      shortLabel: 'Incidencias',
      icon: faTags,
      activeColor: '#2563eb',
      badge: null
    },
    ...(isAdmin ? [{
      id: 'horarios',
      label: 'Horarios',
      shortLabel: 'Horarios',
      icon: faClock,
      activeColor: '#2563eb',
      badge: null
    }] : []),
    {
      id: 'mensajes',
      label: 'Mensajes Automáticos',
      shortLabel: 'Mensajes',
      icon: faRobot,
      activeColor: '#2563eb',
      badge: null
    },
    ...(isAdmin ? [{
      id: 'globales',
      label: 'Globales',
      shortLabel: 'Globales',
      icon: faGlobe,
      activeColor: '#2563eb',
      badge: null
    }] : [])
  ];

  return (
    <>
      {/* 1. Desktop Sub-Sidebar (Visible en pantalla grande) */}
      <aside
        className="se-subsidebar d-none d-lg-flex"
        style={{
          backgroundColor: isDark ? '#121e2d' : '#ffffff',
          borderColor: isDark ? '#233142' : '#e2e8f0'
        }}
      >
        {/* Sub-sidebar Header */}
        <div
          className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom"
          style={{ borderColor: isDark ? '#233142' : '#e2e8f0' }}
        >
          <div
            className="d-flex align-items-center justify-content-center rounded-2 flex-shrink-0"
            style={{
              width: '32px',
              height: '32px',
              minWidth: '32px',
              backgroundColor: isDark ? '#1e293b' : '#e0e7ff',
              color: isDark ? '#818cf8' : '#4338ca'
            }}
          >
            <FontAwesomeIcon icon={faCog} style={{ fontSize: '0.95rem' }} />
          </div>

          <div>
            <h6
              className="fw-bold mb-0"
              style={{
                fontSize: '0.95rem',
                lineHeight: 1.2,
                color: isDark ? '#f9fafd' : '#0f172a'
              }}
            >
              Configuración
            </h6>
            <small
              className="text-muted"
              style={{ fontSize: '0.72rem', color: isDark ? '#94a3b8' : '#64748b' }}
            >
              Mesa de Ayuda
            </small>
          </div>
        </div>

        {/* Submenu Items Desktop */}
        <nav className="d-flex flex-column gap-1 flex-grow-1">
          {menuItems.map(item => {
            const isActive = activeSubTab === item.id;
            return (
              <button
                key={item.id}
                onClick={() => {
                  setActiveSubTab(item.id);
                  if (onClose) onClose();
                }}
                className={`se-nav-btn text-decoration-none d-flex justify-content-between align-items-center ${isActive ? 'active' : ''}`}
              >
                <div className="d-flex align-items-center gap-2">
                  <FontAwesomeIcon
                    icon={item.icon}
                    style={{
                      color: isActive ? item.activeColor || '#4338ca' : (isDark ? '#94a3b8' : '#64748b'),
                      width: '18px'
                    }}
                  />
                  <span style={{ color: isActive ? (isDark ? '#f8fafc' : '#1e293b') : (isDark ? '#94a3b8' : '#64748b') }}>
                    {item.label}
                  </span>
                </div>
              </button>
            );
          })}
        </nav>
      </aside>

      {/* 2. Mobile Fixed Bottom Tab Bar (Barra de opciones fija abajo en móvil) */}
      <nav
        className="se-settings-bottom-bar d-lg-none"
        aria-label="Navegación de configuración"
      >
        {/* Botón casita para regresar al menú principal */}
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            className="se-bottom-tab-btn se-bottom-tab-home-btn"
            title="Volver al Menú Principal"
            aria-label="Volver al Menú Principal"
          >
            <FontAwesomeIcon icon={faHome} />
            <span>Menú</span>
          </button>
        )}

        {/* Separador vertical sutil */}
        <div className="se-bottom-tab-divider" />

        {/* Opciones de Configuración fijas abajo */}
        {menuItems.map(item => {
          const isActive = activeSubTab === item.id;
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => setActiveSubTab(item.id)}
              className={`se-bottom-tab-btn ${isActive ? 'active' : ''}`}
              title={item.label}
              style={isActive ? { color: item.activeColor || '#4338ca' } : {}}
            >
              <FontAwesomeIcon
                icon={item.icon}
                style={isActive ? { color: item.activeColor || '#4338ca' } : {}}
              />
              <span>{item.shortLabel || item.label}</span>
            </button>
          );
        })}
      </nav>
    </>
  );
};

export default SupportEngineSettingsSidebar;
